import { CART_MODULE } from "@/api_framework/api_config";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import { useConfiguration } from "../../useConfiguration";

export interface IMirrorStateResponseData {
  screen: string;
  status: string;
  cart_id?: string | null;
  customer_id?: string | null;
  [key: string]: unknown;
}

interface IMirrorStateResponse {
  status: boolean;
  message: string;
  data: IMirrorStateResponseData;
}

const DEFAULT_MIRROR_STATE: IMirrorStateResponseData = { screen: "idle", status: "IDLE" };

export const useFetchMirrorStateAPI = () => {
  const configuration = useConfiguration();

  const execute = useCallback(async (): Promise<IMirrorStateResponseData> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const endpoint = CART_MODULE?.MIRROR_STATE?.baseURL ?? "";

      return await axios
        .get(endpoint, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IMirrorStateResponse>) => res.data?.data ?? DEFAULT_MIRROR_STATE)
        .catch((e: AxiosError) => {
          console.error("[MirrorState] failed to fetch:", e);
          return DEFAULT_MIRROR_STATE;
        });
    } catch (e) {
      console.error("[MirrorState] failed to fetch:", e);
      return DEFAULT_MIRROR_STATE;
    }
  }, [configuration]);

  return { execute };
};
